// OUTLATE THEME — JavaScript

document.addEventListener('DOMContentLoaded', function () {

  // ===== HERO SLIDESHOW =====
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  let current = 0;
  let timer;

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = index;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  function next() {
    goTo((current + 1) % slides.length);
  }

  function startTimer() {
    timer = setInterval(next, 5000);
  }

  if (slides.length > 0) {
    slides[0].classList.add('active');
    if (dots.length > 0) dots[0].classList.add('active');
    startTimer();

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(i);
        startTimer();
      });
    });
  }

  // ===== SIZE SELECTOR =====
  const sizeBtns = document.querySelectorAll('.size-btn');
  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const group = btn.closest('.size-options');
      if (group) {
        group.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('selected'); });
      }
      btn.classList.add('selected');
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }
    });
  });

  // ===== ADD TO CART AJAX =====
  const addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        updateCartCount();
        showCartNotification();
      })
      .catch(function (err) { console.error('Add to cart error:', err); });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      });
  }

  function showCartNotification() {
    let notif = document.querySelector('.cart-notification');
    if (!notif) {
      notif = document.createElement('div');
      notif.className = 'cart-notification';
      notif.style.cssText = 'position:fixed;bottom:32px;right:32px;background:#f0e040;color:#0a0a0a;font-family:"Bebas Neue",sans-serif;font-size:16px;letter-spacing:0.15em;padding:16px 28px;z-index:9999;transform:translateY(20px);opacity:0;transition:all 0.3s;';
      document.body.appendChild(notif);
    }
    notif.textContent = 'ADDED TO CART';
    setTimeout(function () { notif.style.transform = 'translateY(0)'; notif.style.opacity = '1'; }, 10);
    setTimeout(function () { notif.style.transform = 'translateY(20px)'; notif.style.opacity = '0'; }, 2500);
  }

  // ===== NEWSLETTER FORM =====
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = newsletterForm.querySelector('.newsletter-btn');
      if (btn) {
        btn.textContent = 'SUBSCRIBED!';
        setTimeout(function () { btn.textContent = 'SUBSCRIBE'; }, 3000);
      }
    });
  }

  // Initialize cart count on load
  updateCartCount();
});
